import { useEffect, useState } from 'react';
import { customerService } from '@services/api/customerService';
import type { Beneficiary } from '@/types/customer';
import '../CustomerTabs.css';

interface PaymentControlsTabProps {
  customerId: string;
}

export const PaymentControlsTab = ({ customerId }: PaymentControlsTabProps) => {
  const [beneficiaries, setBeneficiaries] = useState<Beneficiary[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadBeneficiaries();
  }, [customerId]);

  const loadBeneficiaries = async () => {
    const result = await customerService.getCustomerBeneficiaries(customerId);
    if (result.success && result.data) {
      setBeneficiaries(result.data);
    }
    setLoading(false);
  };

  if (loading) return <div>Loading beneficiaries...</div>;

  return (
    <div className="tab-content-wrapper">
      <div className="info-card">
        <h3 className="info-card-title">👥 Beneficiary List</h3>
        
        {beneficiaries.length === 0 ? (
          <p className="text-secondary">No beneficiaries found</p>
        ) : (
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Type</th>
                  <th>Bank/Details</th>
                  <th>Currency</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {beneficiaries.map((ben) => (
                  <tr key={ben.id}>
                    <td className="font-weight-600">{ben.contact_name}</td>
                    <td>{ben.beneficiary_type}</td>
                    <td className="text-small">
                      {ben.bank_name || ben.iban || ben.phone_number || 'N/A'}
                    </td>
                    <td>{ben.currency}</td>
                    <td>
                      <span className={`status-badge status-${ben.is_verified ? 'green' : 'orange'}`}>
                        {ben.is_verified ? 'Verified' : 'Unverified'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

